<div class="grid grid-cols-2 gap-x-6 gap-y-4 min-h-0 overflow-auto">
	<app-cosmolex-accounting-items-table
		class="col-span-1"
		id="hstDisbursementsTable"
		[hst]="hst$ | async"
		[hstTotal]="(totals$ | async)?.HSTDisbursementsHST"
		title="HST disbursements"
		[items]="cosmolexHstItems$ | async"
	></app-cosmolex-accounting-items-table>
	<app-cosmolex-accounting-items-table
		class="col-span-1"
		title="Non HST disbursements"
		[items]="cosmolexNonHstItems$ | async"
	></app-cosmolex-accounting-items-table>
</div>
